/**
 * Maps the V1 request body and V1 response body to a V2 request body
 *
 * @param {*} v1Request - Represents the V1 create request body
 * @param {import("../js-doc").V2MappingOptions} v2MappingOptions - V2 mapping options
 * @returns {import("../js-doc").V2ExpediteTransferRequest}
 */
// eslint-disable-next-line max-len
export const mapV1ExpediteTransferRequestToV2ExpediteTransferRequestBody = (v2MappingOptions, v1Request) => {
  return {
    __v1Payload: v1Request,
    __ingestThrough: v2MappingOptions.ingestThrough,
    clientId: v1Request.clientId,
  }
}


/**
 * Maps the V1 request body and V1 response body to a V2 request body
 *
 * @param {import("../js-doc").V2MappingOptions} v2MappingOptions - V2 mapping options
 * @param {import("../js-doc").V1DebitTransferRequest} v1Request - Represents the V1 create request body
 * @param {string} clientId - Client iD
 * @returns {import("../js-doc").V2DebitTransferRequest}
 */
// eslint-disable-next-line max-len
export const mapV1DebitTransferRequestToV2DebitTransferRequestBody = (v2MappingOptions, v1Request, clientId) => {
  return {
    __v1Payload: v1Request,
    __ingestThrough: v2MappingOptions.ingestThrough,
    clientId: clientId,
    bankAccountId: v1Request.client_bank_account_id,
    amount: v1Request.amount,
  }
}
